import {cardTitle, tooltip} from "assets/jss/material-dashboard-pro-react.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import customInfoLabels from "assets/jss/material-dashboard-pro-react/customInfoLabels.jsx";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";

const pagamentosStyle = {
  ...customCheckboxRadioSwitch,
  ...customInfoLabels,
  tooltip,
  cardTitle,
  tabelaPagamentos: {
    borderCollapse: "collapse",
    marginTop: 4,
    width: '100%',
    "& td": {
      borderBottom: "1px solid #ececec",
      padding: 12,
      fontSize: 12
    }
  },
  ...buttonStyle,
  modalCardTitle: {
    fontSize: "20px",
    position: "relative",
    top: "5px",
    left: "10px"
  }
};

export default pagamentosStyle;
